import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery(
    $companyId: ID!
    $filters: [Filter]
  ) {
    Me {
      id
      Company(id: $companyId) {
        data: countUsageUnits(
          options: { filters: $filters }
          context: RecentRegularAppointment
        )
      }
    }
  }
`
